import { Modal, ModalContent } from '@nextui-org/react';
import { useTranslation } from 'react-i18next';

/**
 * One simple question before the browser's own: what arrives is news from the team, and the phone asks next. "Ativar"
 * calls the browser from that tap. After it: "Pronto" in place, or why it didn't work.
 */
export const PushOptInSheet = ({ open, busy, done, error, onEnable, onClose }) => {
  const { t } = useTranslation();
  const copy = (key) => t(`components.PushOptIn.${key}`);

  return (
    <Modal
      isOpen={open}
      onOpenChange={(isOpen) => !isOpen && onClose()}
      placement="auto"
      hideCloseButton
      isDismissable={!busy}
      aria-label={copy('title')}
      classNames={{ base: 'mt-root mt-dialog mt-install-sheet', backdrop: 'mt-dialog__backdrop' }}
    >
      <ModalContent>
        {() =>
          done ? (
            <div className="mt-dialog__body mt-install-sheet__body">
              <h2 className="mt-dialog__title">{copy('doneTitle')}</h2>
              <p className="mt-dialog__text" role="status">
                {copy('done')}
              </p>
              <div className="mt-install-sheet__actions">
                <button type="button" className="mt-btn mt-btn--quiet" onClick={onClose}>
                  {t('standalone.close')}
                </button>
              </div>
            </div>
          ) : (
            <div className="mt-dialog__body mt-install-sheet__body">
              <h2 className="mt-dialog__title">{copy('title')}</h2>
              <p className="mt-dialog__text">{copy('text')}</p>
              {error && (
                <p className="mt-install-sheet__error" role="alert">
                  {copy(error)}
                </p>
              )}
              <div className="mt-install-sheet__actions">
                <button type="button" className="mt-btn mt-btn--primary" onClick={onEnable} disabled={busy} aria-busy={busy || undefined}>
                  {busy && <span className="mt-btn__spinner" aria-hidden="true" />}
                  {copy('enable')}
                </button>
                <button type="button" className="mt-btn mt-btn--quiet" onClick={onClose} disabled={busy}>
                  {copy('later')}
                </button>
              </div>
            </div>
          )
        }
      </ModalContent>
    </Modal>
  );
};
